import { WidgetBase } from '@/core/widgets/model/news-widget';
import { useEffect, useState } from 'react';
import { useEffectivePermissions } from '@/core/permissions/export';

/** A missing widget (e.g. a deep-dive app that isn't registered) is not authorized. */
export function useWidgetPermission(widget: WidgetBase | undefined): {
  authorized?: boolean;
  loadingPermission: boolean;
} {
  const [state, setState] = useState<{ authorized?: boolean; loadingPermission: boolean }>({
    loadingPermission: true,
  });
  const permissions = useEffectivePermissions();

  useEffect(() => {
    let cancelled = false;

    if (!widget) {
      setState({ authorized: false, loadingPermission: false });
      return;
    }

    widget.hasPermission(permissions).then(
      value => {
        if (cancelled) return;

        setState({
          authorized: value,
          loadingPermission: false,
        });
      },
      reason => {
        if (cancelled) return;

        setState({
          authorized: false,
          loadingPermission: false,
        });
      },
    );

    return () => {
      cancelled = true;
    };
  }, [widget, permissions]);

  return state;
}
